<div id="documentPanelList" *ngIf="isPanelListDataAvailable">
  <div *ngIf="openPdfPreviewModal">
    <app-pdf-preview [resourceUrl]="readOnlyFileUrl" [isPdfPreviewModalShow]="openPdfPreviewModal" 
    (showPdfPreviewModal)="showPdfPreviewModal($event)">
    </app-pdf-preview>
  </div>
  <div *ngIf="panelCardViewType == defaultView">
  <app-panel-list *ngIf="!showLoader || !isSearch" [showLoader] = "showLoader" [panelList]="documentsPanelListData" 
  [noResultFound] = "noData"
  (selectedItems)="getSelectedItems($event)" [ifAdditionalItems]="true"
  [defaultFiltersSelected] = "defaultFiltersSelected" (exportExcelEvent)="exportExcel()" [isExportButtonAvailable]="isExportButtonAvailable"
  (panelCardViewTypeEvent)="checkPanelCardViewType($event)"
  (panelCardViewEvent)="switchPanelCardView()">
    <span class="additional-items">
      <p-checkbox 
    class="col p-0 pr-2"
    name="showInactive"
    value="all"
    *ngIf="isShowCheckbox === true"
    [(ngModel)]="selectCheckbox"
    [binary]="true"
    (onChange)="checkboxSelectionChange()"
    ></p-checkbox>
    <label *ngIf="enableInactiveLabel">
      {{checkboxLabel}}
    </label>
    <i 
    *ngIf="showInformationIconCheckbox === true"
    class="fa fa-info-circle ml-2 info-icon-color"
    aria-hidden="true"
    pTooltip="{{ informationIconTooltip }}"
  ></i>
    </span>
      <ng-template #templateRef let-data="dataVar">
        <div class="card">
          <div class="card-container">
            <div class="flex">
              <div class="overflow-ellipse flex-initial flex underline document-header font-semibold">
                <div *ngIf="data?.phase!= cancelledDocumentPhaseConstant">
                 
                  <em class="blue-color cursor-pointer" (click)="downloadSourceFile(data.documentNumber,data.version, data.phase,data.printLock)">
                  <em class="fa-solid fa-file fileIconStyle"></em></em>
                </div>
                <b pTooltip= "{{data.documentNumber}} {{data.title}} (v{{data.version}})">
                  <a style="cursor: pointer;" (click)="openDocument(data?.documentNumber,data?.version)">{{ data?.documentNumber }} {{(data?.title.length>90)? 
                  (data?.title | slice:0:90)+'..':(data?.title)}} (v{{ data?.version }})</a></b></div>
              <div class="flex-initial flex justify-content-center font-semibold icon-alignment">
                <b><i class="pi pi-circle-fill green-button"
                  [ngClass]="calculatePhaseColor(data.phase)"></i></b> &nbsp;
                  <div class="iconAlignment">
                    {{displayPhaseLabelWithDate(data?.phase,data.effectiveDate,data.requestedEffectiveDate)}} &nbsp;
                  </div>
                  <button *ngIf="data?.isFavorite && !enableFavoriteButton"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-star-fill favoriteIconColor"
                    class="p-button-rounded p-button-text favoriteIconStyle"
                  ></button>
                  <button appPreventDoubleClick *ngIf="data?.isFavorite && enableFavoriteButton"
                    pButton
                    pRipple
                    [pTooltip]=getFavoriteToolTip()
                    type="button"
                    icon="pi pi-star-fill favoriteIconColor"
                    class="p-button-rounded p-button-text favoriteIconStyleButton"
                    (debounceClick)="updateDocumentFavourite(data.documentNumber)"
                  ></button>&nbsp;
                  <span class="fa fa-lightbulb btnBlueColored" pTooltip="Change Request History" *ngIf="data?.changeRequestItemsCount > 0"
                  ></span>
                  <span  class="notificationSectionCount_Badge"
                    pTooltip="Change Request History"
                    *ngIf="data?.changeRequestItemsCount > 0"
                  >
                  {{data?.changeRequestItemsCount}}          
                  </span>  
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #templateRef let-data="dataVar">
        <div class="grid">
          <div class="col-fixed" style="width: 15%">
            <div class="font-semibold mb-1">Legacy Document #</div>
            <div class="content-wrap">
              {{ data?.legacyDocumentNumber }}
            </div>
          </div>
          <div class="col-fixed" style="width: 12%">
            <div class="font-semibold mb-1">Next Review Date</div>
            <div class="content-wrap">
              {{data?.nextReviewDate | date:'dd-MMM-yyyy'}}
            </div>
          </div>
          <div class="col-fixed" style="width: 16%">
            <div class="font-semibold mb-1">Sub-BU</div>
            <div class="content-wrap">
              {{ data?.responsibleSubBU }}
            </div>
          </div>
          <div class="col-fixed" style="width: 14%">
          <div class="font-semibold mb-1">Category</div>
            <div class="content-wrap">
              {{ data?.category }}<br *ngIf="data?.category !== null && data?.category != undefined && data?.localCategory !== null && data?.localCategory != undefined">{{data?.localCategory}}
            </div>
          </div>
          <div class="col-fixed" style="width: 14%">
            <div class="font-semibold mb-1">Type</div>
            <div class="content-wrap">
              {{ data?.documentType }}<br *ngIf="data?.documentType !== null && data?.documentType != undefined && data?.localType !== null && data?.localType != undefined">{{data?.localType}}
            </div>
          </div>
          <div class="col-fixed" style="width: 10%" *ngIf="data?.queuePanelCardDisplay == displayAssignedAdmin">
            <div class="font-semibold mb-1">Assigned Admin(s)</div>
            <div [pTooltip]="calculateToolTip(data?.assignedAdmins)">
              <div *ngFor="let assignedAdmin of data?.assignedAdmins.slice(0,3)">
                <div class="content-wrap" [ngClass]="{'inActiveGroup': assignedAdmin.isActive == false || assignedAdmin.isTerminated===true }">
                  {{ assignedAdmin.name }}
                </div>
              </div>
              <div *ngIf="data?.assignedAdmins.length > 3"> ...</div>
            </div>
          </div>
          <div class="col-fixed" style="width: 10%" *ngIf="data?.queuePanelCardDisplay == displayAssignedQas">
            <div class="font-semibold mb-1">Assigned QA(s)</div>
            <div [pTooltip]="calculateToolTip(data?.assignedQas)">
            <div class="content-wrap" *ngFor="let assignedQa of data?.assignedQas.slice(0,3)" [ngClass]="{'inActiveGroup': assignedQa.isActive == false || assignedQa.isTerminated===true}">
              {{ assignedQa.name }}
            </div>
          </div>
            </div>
          <div class="col-fixed" style="width: 10%" *ngIf="data?.queuePanelCardDisplay == displayApprovers">
            <div class="font-semibold mb-1">Approver(s)</div>
              <div *ngFor="let approver of data?.approversInformation">
                <div class="content-wrap" [ngClass]="{'inActiveGroup': approver.isTerminated===true }">
                  {{ approver.name }}
                </div>
             </div>
          </div>
          <div class="col-fixed" style="width: 10%" *ngIf="data.queuePanelCardDisplay == displayAssignedDocControls">
            <div class="font-semibold mb-1">Assigned Doc Control</div>
              <div *ngFor="let assignedDocControl of data?.assignedDocControls">
                <div class="content-wrap"  [ngClass]="{'inActiveGroup': assignedDocControl.isActive == false || assignedDocControl.isTerminated===true }">
                  {{ assignedDocControl.name }}
                </div>
              </div>
          </div>
          <div class="col-fixed" style="width: 10%" *ngIf="data.queuePanelCardDisplay == displayCollaborators">
            <div class="font-semibold mb-1">Collaborator(s)</div>
            <div *ngFor="let collaborator  of data?.collaborators">
              <div class="content-wrap" [ngClass]="{'inActiveGroup': collaborator.isActive == false || collaborator.isTerminated===true  }">
                {{ collaborator.name }}
              </div>
            </div>
          </div>
          <div class="col-fixed" style="width: 10%" *ngIf="data.queuePanelCardDisplay == displayInternalClientContacts">
            <div class="font-semibold mb-1">Internal Client Contact(s)</div>
            <div *ngFor="let internalClientContact of data?.internalClientContacts">
              <div class="content-wrap" [ngClass]="{'inActiveGroup': internalClientContact.isTerminated===true  }">
                {{ internalClientContact.name }}
              </div>
            </div>
          </div>
          <div class="col-fixed" style="width: 17%">
            <div class="font-semibold mb-1">eQMS Scope</div>
            <div class="content-wrap" *ngFor="let scope of data?.eQMSScopeDisplayNames">
              {{ scope }}
            </div>
          </div>
        </div>
      </ng-template>
    </app-panel-list>
  </div>
  <div *ngIf="panelCardViewType== assignmentView">
    <app-panel-list *ngIf="!showLoader || !isSearch" [showLoader] = "showLoader" [panelList]="documentsPanelListData" 
    [noResultFound] = "noData"
    (selectedItems)="getSelectedItems($event)" [ifAdditionalItems]="true"
    [defaultFiltersSelected] = "defaultFiltersSelected" (exportExcelEvent)="exportExcel()" [isExportButtonAvailable]="isExportButtonAvailable"
    (panelCardViewTypeEvent)="checkPanelCardViewType($event)"
    (panelCardViewEvent)="switchPanelCardView()">
      <span class="additional-items">
        <p-checkbox 
      class="col p-0 pr-2"
      name="showInactive"
      value="all"
      *ngIf="isShowCheckbox === true"
      [(ngModel)]="selectCheckbox"
      [binary]="true"
      (onChange)="checkboxSelectionChange()"
      ></p-checkbox>
      <label *ngIf="enableInactiveLabel">
        {{checkboxLabel}}
      </label>
      <i 
      *ngIf="showInformationIconCheckbox === true"
      class="fa fa-info-circle ml-2 info-icon-color"
      aria-hidden="true"
      pTooltip="{{ informationIconTooltip }}"
    ></i>
      </span>
        <ng-template #templateRef let-data="dataVar">
          <div class="card">
            <div class="card-container">
              <div class="flex">
                <div class="overflow-ellipse flex-initial flex underline document-header font-semibold">
                  <div *ngIf="data?.phase!= cancelledDocumentPhaseConstant">
                    <em class="blue-color cursor-pointer" (click)="downloadSourceFile(data.documentNumber,data.version, data.phase,data.printLock)">
                    <em class="fa-solid fa-file fileIconStyle"></em></em>
                  </div>
                  <b pTooltip= "{{data.documentNumber}} {{data.title}} (v{{data.version}})">
                    <a style="cursor: pointer;" (click)="openDocument(data?.documentNumber,data?.version)">{{ data?.documentNumber }} {{(data?.title.length>90)? 
                    (data?.title | slice:0:90)+'..':(data?.title)}} (v{{ data?.version }})</a></b></div>
                <div class="flex-initial flex justify-content-center font-semibold icon-alignment">
                  <b><i class="pi pi-circle-fill green-button"
                    [ngClass]="calculatePhaseColor(data.phase)"></i></b> &nbsp;
                    <div class="iconAlignment">
                      {{displayPhaseLabelWithDate(data?.phase,data.effectiveDate,data.requestedEffectiveDate)}} &nbsp;
                    </div>
                    <button *ngIf="data?.isFavorite && !enableFavoriteButton"
                      pButton
                      pRipple
                      type="button"
                      icon="pi pi-star-fill favoriteIconColor"
                      class="p-button-rounded p-button-text favoriteIconStyle"
                    ></button>
                    <button appPreventDoubleClick *ngIf="data?.isFavorite && enableFavoriteButton"
                      pButton
                      pRipple
                      [pTooltip]=getFavoriteToolTip()
                      type="button"
                      icon="pi pi-star-fill favoriteIconColor"
                      class="p-button-rounded p-button-text favoriteIconStyleButton"
                      (debounceClick)="updateDocumentFavourite(data.documentNumber)"
                    ></button>&nbsp;
                    <span class="fa fa-lightbulb btnBlueColored" pTooltip="Change Request History" *ngIf="data?.changeRequestItemsCount > 0"
                    ></span>
                    <span  class="notificationSectionCount_Badge"
                      pTooltip="Change Request History"
                      *ngIf="data?.changeRequestItemsCount > 0"
                    >
                    {{data?.changeRequestItemsCount}}          
                    </span>  
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #templateRef let-data="dataVar">
          <div class="grid">
            <div class="col-fixed" style="width: 10%">
              <div class="font-semibold mb-1">Author</div>
              <div class="content-wrap" [ngClass]="{'inActiveGroup': data?.isAuthorTerminated == true}">
                {{ data?.author }}
              </div>
            </div>
            <div class="col-fixed" style="width: 10%">
              <div class="font-semibold mb-1">Assigned Admin(s)</div>
              <div [pTooltip]="calculateToolTip(data?.assignedAdmins)">
                <div *ngFor="let assignedAdmin of data?.assignedAdmins.slice(0,3)">
                  <div class="content-wrap"[ngClass]="{'inActiveGroup': assignedAdmin.isActive == false || assignedAdmin.isTerminated===true }">
                    {{ assignedAdmin.name }}
                  </div>
                </div>
                <div *ngIf="data?.assignedAdmins.length > 3"> ...</div>
              </div>
            </div>
            <div class="col-fixed" style="width: 10%">
              <div class="font-semibold mb-1">Collaborator(s)</div>
              <div *ngFor="let collaborator  of data?.collaborators">
                <div class="content-wrap" [ngClass]="{'inActiveGroup': collaborator.isActive  == false || collaborator.isTerminated===true}">
                  {{ collaborator.name }}
                </div>
              </div>
            </div>
            <div class="col-fixed" style="width: 10%">
              <div class="font-semibold mb-1">Assigned QA(s)</div>
                <div [pTooltip]="calculateToolTip(data?.assignedQas)">
                  <div class="content-wrap" *ngFor="let assignedQa of data?.assignedQas.slice(0,3)" [ngClass]="{'inActiveGroup': assignedQa.isActive  == false || assignedQa.isTerminated===true}">
                    {{ assignedQa.name }}
                  </div>
                </div>
              </div>
            <div class="col-fixed" style="width: 10%">
              <div class="font-semibold mb-1">Assigned Doc Control(s)</div>
                <div *ngFor="let assignedDocControl of data?.assignedDocControls">
                  <div class="content-wrap"  [ngClass]="{'inActiveGroup': assignedDocControl.isActive == false || assignedDocControl.isTerminated===true }">
                    {{ assignedDocControl.name }}
                  </div>
                </div>
            </div>
            <div class="col-fixed" style="width: 10%" >
              <div class="font-semibold mb-1">Reviewer(s)</div>
                <div *ngFor="let reviewer of data?.reviewersInformation">
                  <div class="content-wrap" [ngClass]="{'inActiveGroup': reviewer.isTerminated===true }">
                    {{ reviewer.name }}
                  </div>
               </div>
            </div>
            <div class="col-fixed" style="width: 10%" >
              <div class="font-semibold mb-1">Approver(s)</div>
                <div *ngFor="let approver of data?.approversInformation">
                  <div class="content-wrap" [ngClass]="{'inActiveGroup': approver.isTerminated===true }">
                    {{ approver.name }}
                  </div>
               </div>
            </div>
            <div class="col-fixed" style="width: 10%">
              <div class="font-semibold mb-1">Periodic Reviewer(s)</div>
              <div class="content-wrap" *ngFor="let periodicReviewer of data?.periodicReviewersInformation">
                <div class="content-wrap" [ngClass]="{'inActiveGroup': periodicReviewer.isTerminated===true }">
                  {{ periodicReviewer.name }}
                </div>
              </div>
            </div>
            <div class="col-fixed" style="width: 10%">
              <div class="font-semibold mb-1">Internal Client Contact(s)</div>
              <div *ngFor="let internalClientContact of data?.internalClientContacts">
                <div class="content-wrap" [ngClass]="{'inActiveGroup': internalClientContact.isTerminated===true }">
                  {{ internalClientContact.name }}
                </div>
              </div>
            </div>
            
          </div>
        </ng-template>
      </app-panel-list>
   </div>
   <div *ngIf="panelCardViewType == whereAmIUsedView">
    <app-panel-list [panelList]="documentsPanelListData" [noResultFound] = "noData" (selectedItems)="getSelectedItems($event)" (exportExcelEvent)="exportExcel()"
    [isExportButtonAvailable]="isExportButtonAvailable"
    (panelCardViewTypeEvent)="checkPanelCardViewType($event)"
    (panelCardViewEvent)="switchPanelCardView()">
      <ng-template #assignmentViewRef let-data="dataVar">
        <div class="card">
          <div class="card-container">
            <div class="flex">
              <div class="overflow-ellipse flex-initial flex underline document-header font-semibold">
                <div *ngIf="data?.phase!= cancelledDocumentPhaseConstant">
                  <em class="blue-color cursor-pointer" (click)="downloadSourceFile(data.documentNumber,data.version, data.phase,data.printLock)">
                  <em class="fa-solid fa-file fileIconStyle"></em></em>
                </div>
                <b pTooltip= "{{data.documentNumber}} {{data.title}} (v{{data.version}})">
                  <a style="cursor: pointer;" (click)="openDocument(data?.documentNumber,data?.version)">{{ data?.documentNumber }} {{(data?.title.length>90)? 
                  (data?.title | slice:0:90)+'..':(data?.title)}} (v{{ data?.version }})</a></b></div>
                    <div class="flex-initial flex justify-content-center font-semibold icon-alignment">
                      <b><i class="pi pi-circle-fill green-button"
                        [ngClass]="calculatePhaseColor(data.phase)"></i></b> &nbsp;
                        <div class="iconAlignment">
                          {{displayPhaseLabelWithDate(data?.phase,data.effectiveDate,data.requestedEffectiveDate)}} &nbsp;
                        </div>
                        <button *ngIf="data?.isFavorite && !enableFavoriteButton"
                          pButton
                          pRipple
                          type="button"
                          icon="pi pi-star-fill favoriteIconColor"
                          class="p-button-rounded p-button-text favoriteIconStyle"
                        ></button>
                        <button appPreventDoubleClick *ngIf="data?.isFavorite && enableFavoriteButton"
                          pButton
                          pRipple
                          [pTooltip]=getFavoriteToolTip()
                          type="button"
                          icon="pi pi-star-fill favoriteIconColor"
                          class="p-button-rounded p-button-text favoriteIconStyleButton"
                          (debounceClick)="updateDocumentFavourite(data.documentNumber)"
                        ></button>&nbsp;
                        <span class="fa fa-lightbulb btnBlueColored" pTooltip="Change Request History" *ngIf="data?.changeRequestItemsCount > 0"
                        ></span>
                        <span  class="notificationSectionCount_Badge"
                          pTooltip="Change Request History"
                          *ngIf="data?.changeRequestItemsCount > 0"
                        >
                        {{data?.changeRequestItemsCount}}          
                        </span>  
                    </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #assignmentViewRef let-data="dataVar">
        <div class="grid">
          <div class="col-fixed" style="width: 20%">
            <div class="font-semibold mb-1">eQMS Scope(s)</div>
            <ul>
              <li class="content-wrap" *ngFor="let scopes of data?.eQMSScopeDisplayNames">
                {{ scopes }}
              </li>
            </ul>
          </div>
          <div class="col-fixed" style="width: 25%">
            <div class="font-semibold mb-1">Curriculum(s)</div>
            <ul>
              <li class="content-wrap" *ngFor="let curriculum of data?.curriculums">
                <div class="blue-color cursor-pointer overflow-ellipse flex-initial flex underline course-header font-semibold">
                  <b pTooltip="{{ curriculum?.curriculumScopeName }}">
                    <a style="cursor: pointer" (click)="openCurriculum(curriculum?.curriculumScopeId)">{{ curriculum?.curriculumScopeName }}</a>
                  </b>
                </div> 
              </li>
            </ul>
          </div>
          <div class="col-fixed" style="width:25%">
            <div class="font-semibold mb-1">Training Item Group(s)</div>
            <ul>
              <li class="content-wrap" *ngFor="let trainingItemGroup of data?.trainingGroups">
                <div class="blue-color cursor-pointer overflow-ellipse flex-initial flex underline course-header font-semibold">
                  <b pTooltip="{{ trainingItemGroup?.trainingItemGroupNumber }} {{ trainingItemGroup?.trainingItemGroupName }}">
                    <a style="cursor: pointer" (click)="openTrainingItemGroup(trainingItemGroup?.trainingItemGroupNumber )">
                      {{ trainingItemGroup?.trainingItemGroupNumber }} {{ trainingItemGroup?.trainingItemGroupName }}
                    </a>
                  </b>
                </div> 
              </li>
            </ul>
          </div>
          <div class="col-fixed" style="width:25%">
            <div class="font-semibold mb-1">Related Document(s)</div>
            <ul>
              <li class="content-wrap" *ngFor="let relatedDocument of data?.relatedDocuments">
                <div class="blue-color cursor-pointer overflow-ellipse flex-initial flex underline course-header font-semibold">
                  <b pTooltip="{{ relatedDocument?.relatedDocumentNumber}} {{ relatedDocument?.relatedDocumentTitle }}">
                  <a 
                      style="cursor: pointer" 
                      (click)="openRelatedDocument(
                        relatedDocument?.relatedDocumentNumber,
                        relatedDocument?.relatedDocumentVersion,
                        relatedDocument?.relatedDocumentType
                      )">
                      {{ relatedDocument?.relatedDocumentNumber }} 
                      {{ relatedDocument?.relatedDocumentTitle }} 
                      <ng-container *ngIf="relatedDocument?.relatedDocumentType === 0">
                        (v{{ relatedDocument?.relatedDocumentVersion }})
                      </ng-container>
                    </a>
                  </b>
                </div> 
              </li>
            </ul>
          </div>
        </div>
      </ng-template>
    </app-panel-list>
  </div>
</div>
<p-toast *ngIf="enableToaster" sticky="true"></p-toast>
